<template>
  <div class="test_paper">
    <div class="paper_top flex Flexalign FlexBetween mb-20" v-if="!hideBack">
      <div class="exercise-title">· 作答记录</div>
      <div class="flex Flexalign cursor_pointer" @click="practiceBack">
        <el-image class="back_icon" :src="iconPath('back_icon.png')"></el-image>
        <div class="back_text">返回</div>
      </div>
    </div>
    <div v-for="(sitem, sindex) in testPaperInfo.paperContext" :key="sindex">
      <div v-for="(item, index) in sitem.questions" :key="index">
        <!-- 单选 -->
        <choice v-if="
          (item.questionTypeId == 1 || item.questionTypeId == 9) &&
          testExamInfo.currentQuestionId == item.questionNumber
        " :questionInfo="item" @answerQuestion="answerQuestion"
          :isShowScoring="testExamInfo.isShowScoring || item.isShowScoring" :questionTypeName="sitem.questionTypeName"
          :testType="testType" @showAnalysis="showAnalysis"></choice>
        <!-- 多选 -->
        <multipleChoice v-else-if="
          item.questionTypeId == 2 &&
          testExamInfo.currentQuestionId == item.questionNumber
        " :questionInfo="JSON.stringify(item)" @answerQuestion="answerQuestion"
          :isShowScoring="testExamInfo.isShowScoring || item.isShowScoring" :questionTypeName="sitem.questionTypeName"
          :testType="testType" @showAnalysis="showAnalysis"></multipleChoice>
        <!-- 判断/听力判断 -->
        <trueOrFalseVue v-else-if="
          (item.questionTypeId == 4 || item.questionTypeId == 11) &&
          testExamInfo.currentQuestionId == item.questionNumber
        " :questionInfo="item" @answerQuestion="answerQuestion"
          :isShowScoring="testExamInfo.isShowScoring || item.isShowScoring" :questionTypeName="sitem.questionTypeName"
          :testType="testType" @showAnalysis="showAnalysis"></trueOrFalseVue>
        <!-- 排序 -->
        <sortNew v-else-if="
          (item.questionTypeId == 6 || item.questionTypeId == 15) &&
          testExamInfo.currentQuestionId == item.questionNumber
        " :questionInfo="item" @answerQuestion="answerQuestion"
          :isShowScoring="testExamInfo.isShowScoring || item.isShowScoring" :questionTypeName="sitem.questionTypeName"
          :testType="testType" @showAnalysis="showAnalysis">
        </sortNew>
        <!-- 填空题 -->
        <fillIn v-else-if="
          (item.questionTypeId == 3 || item.questionTypeId == 14) &&
          testExamInfo.currentQuestionId == item.questionNumber
        " :questionInfo="item" @answerQuestion="answerQuestion"
          :isShowScoring="testExamInfo.isShowScoring || item.isShowScoring" :questionTypeName="sitem.questionTypeName"
          :testType="testType" @showAnalysis="showAnalysis">
        </fillIn>
        <!-- 书写解答题 -->
        <textAnswer v-else-if="
          (item.questionTypeId == 7 ||
            item.questionTypeId == 16 ||
            item.questionTypeId == 13 ||
            item.questionTypeId == 17) &&
          testExamInfo.currentQuestionId == item.questionNumber
        " :questionInfo="item" @answerQuestion="answerQuestion"
          :isShowScoring="testExamInfo.isShowScoring || item.isShowScoring" :questionTypeName="sitem.questionTypeName"
          :testType="testType" @showAnalysis="showAnalysis">
        </textAnswer>
        <!-- 综合解答题 -->
        <comprehensiveAnswer v-else-if="
          (item.questionTypeId == 99 || item.questionTypeId == 101) &&
          testExamInfo.currentQuestionId == item.questionNumber
        " :questionInfo="item" @answerQuestion="answerQuestion"
          :isShowScoring="testExamInfo.isShowScoring || item.isShowScoring" :questionTypeName="sitem.questionTypeName"
          :testType="testType" @showAnalysis="showAnalysis">
        </comprehensiveAnswer>
        <!-- 完形填空题 -->
        <clozeTest v-else-if="
          (item.questionTypeId == 102 || item.questionTypeId == 103) &&
          testExamInfo.currentQuestionId == item.questionNumber
        " :questionInfo="item" @answerQuestion="answerQuestion"
          :isShowScoring="testExamInfo.isShowScoring || item.isShowScoring" :questionTypeName="sitem.questionTypeName"
          :testType="testType" @showAnalysis="showAnalysis">
        </clozeTest>
        <!-- 信息匹配题 -->
        <informationMacth v-else-if="
          item.questionTypeId == 32 &&
          testExamInfo.currentQuestionId == item.questionNumber
        " :questionInfo="item" @answerQuestion="answerQuestion"
          :isShowScoring="testExamInfo.isShowScoring || item.isShowScoring" :questionTypeName="sitem.questionTypeName"
          :testType="testType" @showAnalysis="showAnalysis">
        </informationMacth>
        <composition v-else-if="
          (item.questionTypeId == 21 || item.questionTypeId == 22) &&
          testExamInfo.currentQuestionId == item.questionNumber
        " :questionInfo="item" @answerQuestion="answerQuestion"
          :isShowScoring="testExamInfo.isShowScoring || item.isShowScoring" :questionTypeName="sitem.questionTypeName"
          :testType="testType" @showAnalysis="showAnalysis" :isChallenge="isChallenge">

        </composition>
        <!-- 连线题 -->
        <!-- <connection v-else-if="
            item.questionTypeId == 31 &&
            testExamInfo.currentQuestionId == item.questionNumber
          " :questionInfo="item" @answerQuestion="answerQuestion" :isShowScoring="testExamInfo.isShowScoring"
            :questionTypeName="sitem.questionTypeName"></connection> -->
        <div v-else-if="
          item.questionTypeId != 1 &&
          item.questionTypeId != 2 &&
          item.questionTypeId != 4 &&
          item.questionTypeId != 6 &&
          item.questionTypeId != 3 &&
          item.questionTypeId != 7 &&
          item.questionTypeId != 99 &&
          item.questionTypeId != 102 &&
          item.questionTypeId != 103 &&
          item.questionTypeId != 101 &&
          item.questionTypeId != 14 &&
          item.questionTypeId != 15 &&
          item.questionTypeId != 11 &&
          item.questionTypeId != 9 &&
          item.questionTypeId != 16 &&
          item.questionTypeId != 13 &&
          item.questionTypeId != 17 &&
          item.questionTypeId != 32 &&
          item.questionTypeId != 21 &&
          item.questionTypeId != 22 &&
          // item.questionTypeId != 31 &&
          testExamInfo.currentQuestionId == item.questionNumber
        ">
          <moe-empty url="development_icon.png" emptyText="更多题型开发中"></moe-empty>
        </div>
      </div>
    </div>
    <div class="flex Flexalign btn_box mar_top_30">
      <div class="btn_previous_question cursor_pointer" @click="getPreviousQuestion">
        上一题
      </div>
      <div class="btn_next_question mar_left_30 cursor_pointer" @click="showAnalysis" v-if="
        (testExamInfo.otherRule?.answerFeedback == 1 ||
          testExamInfo.otherRule?.answerFeedback == 2) &&
        testExamInfo.otherRule?.mode == 1
      ">
        查看结果
      </div>
      <div class="btn_next_question mar_left_30 cursor_pointer" @click="getNextQuestion">
        下一题
      </div>
    </div>
  </div>
</template>

<script>
import choice from "@/components/testPaper/choice.vue";
import multipleChoice from "@/components/testPaper/multipleChoice.vue";
import { mapState } from "vuex";
import trueOrFalseVue from "@/components/testPaper/trueOrFalse.vue";
import sortNew from "@/components/testPaper/sortNew.vue";
import fillIn from "@/components/testPaper/fillIn.vue";
import textAnswer from "@/components/testPaper/textAnswer.vue";
import comprehensiveAnswer from "@/components/testPaper/comprehensiveAnswer.vue";
import clozeTest from "@/components/testPaper/clozeTest.vue";
import informationMacth from "@/components/testPaper/informationMacth.vue";
import composition from "@/components/testPaper/composition.vue";
// import connection from "@/components/testPaper/connection.vue";
export default {
  name: "GjkcH5TestPaper",
  components: {
    choice,
    multipleChoice,
    trueOrFalseVue,
    sortNew,
    fillIn,
    textAnswer,
    comprehensiveAnswer,
    clozeTest,
    informationMacth,
    // connection
    composition,
  },
  computed: {
    ...mapState({
      testExamInfo: (state) => state.exam.testExamInfo,
      questionTypeList: (state) => state.exam.questionTypeList,
      currentQuestionId: (state) => state.exam.currentQuestionId,
      isChallengeSubmit: (state) => state.exam.isChallengeSubmit,
      challengeSort: (state) => state.exam.challengeSort,
      selectLearningInfo: (state) => state.learning.selectLearningInfo,
    }),
  },
  props: {
    examInfo: {},
    testTitle: {},
    testType: {},
    isHome: {},
    isChallenge: {},
    hideBack:{}
  },
  watch: {
    // 监听缓存的考试信息，如果提交完展示得分，停止计时
    testExamInfo: {
      handler() {
        if (this.testExamInfo.isShowScoring) {
          if (this.timerInterval) {
            clearInterval(this.timerInterval);
            this.timerInterval = "";
          }
        }
      },
      deep: true,
    },
    examInfo: {
      handler(val) {
        this.testPaperInfo = this.$Tools.copyObj(val);
        this.startTime = this.$Moment().format("YYYY-MM-DD HH:mm:ss");
        this.handleTestPaperInfo();
      },
      deep: true,
      immediate: true,
    },
    currentQuestionId: {
      handler() {
        this.testPaperInfo.currentQuestionId = this.currentQuestionId;
      },
    },
  },
  data() {
    return {
      testPaperInfo: {},
      timerInterval: "",
      startTime: "",
      progressList: [
        { label: "答题进度", finishedNum: 10, total: 100, type: "fraction" },
        { label: "答题时间", finishedNum: 90, total: 300, type: "time" },
        { label: "正确率", finishedNum: 20, total: 100, type: "percent" },
      ],
      // 当前题目ID
      // currentQuestionId:'',
      pushIndex: 0,
      paperCommitBackInfo: {}, // 闯关返回结果
    };
  },

  created() { },
  unmounted() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
      this.timerInterval = "";
    }
    // 刷新答题卡缓存
    this.$emit("refreshTextExam");
    // 清空缓存的试卷信息
    this.$store.commit("exam/setTestExamInfo", {});
    this.$store.commit("exam/setCurrentQuestionId", "");
    this.$store.commit("exam/setIsChallengeSubmit", false);
  },

  methods: {
    formatContent(percentage, info) {
      if (info.type == "fraction") {
        return `${info.finishedNum}/${info.total}`;
      } else if (info.type == "time") {
        return this.$Tools.secondToMinuteFormat(info.finishedNum);
      } else if (info.type == "percent") {
        return (info.finishedNum / info.total) * 100 + "%";
      }
    },
    formatColor(percentage, info) {
      if (info.type == "fraction") {
        return `RGBA(0, 213, 189, 1)`;
      } else if (info.type == "time") {
        return "RGBA(255, 130, 0, 1)";
      } else if (info.type == "percent") {
        return `RGBA(0, 213, 189, 1)`;
      }
    },
    // 随堂练习返回
    practiceBack() {
      this.$emit("practiceBack", false, this.isHome, this.isChallenge);
    },
    backStep() {
      if (!this.testTitle) {
        this.$emit("backStep", 2);
      } else {
        this.$emit("practiceBack", false, this.isHome);
      }
    },
    // 处理试卷内容
    handleTestPaperInfo() {
      // 判断试题内容是否存在
      if (this.testPaperInfo.paperContext) {
        this.testPaperInfo.paperContext.forEach((sitem) => {
          sitem.questions.forEach((item) => {
            // 解析富文本图片配置
            item.questionAnalyze = this.handlerImg(item.questionAnalyze);
            item.questionTitle = this.handlerImg(item.questionTitle);
            item.questionExplanation = this.handlerImg(item.questionExplanation);
            // 处理批语
            if(item.markerComment){
              item.markerComment = this.handlerImg(item.markerComment);
            }
            // 没有提交过需要配置(作业无配置，此处看是否需要添加测试判断是否限制提交次数)
            // if (!item.courseExamRecordId) {
            item.questionContext = {
              ...item.questionContext,
              // doAnswer: "",
              showAnalysis: true,
              startTime: this.startTime,
              isFinish: true,
              isShowScoring: true,
            }; // 新增用户填的答案字段doAnswer,是否显示解析showAnalysis,是否已完成isFinish
            // item.doAnswer = ""; // 答案
            // item.isCorrect = 2; // 是否正确：1：正确 2：错误
            item.questionScore =
              item.isCorrect == 1 ? item.questionContext.score : (item.questionScore || 0); // 得分
            item.startTime = this.startTime;
            // 此处加上判断不同题型的doAnswer格式不同（如多选题需为数组）
            // if (item.questionTypeId == 2) {
            //   item.doAnswer = [];
            // }
            // 此处加上判断,当为填空题的时候，此时要再每个空上面加入一个用户答案字段（用来判断正确与否）
            // if (item.questionTypeId == 3) {
            //   item.questionContext?.options.forEach((item) => {
            //     item.doAnswer = "";
            //   });
            // }
            // 此处加上判断,当为综合解答题/完形填空的时候
            // if (
            //   item.questionTypeId == 99 ||
            //   item.questionTypeId == 101 ||
            //   item.questionTypeId == 102 ||
            //   item.questionTypeId == 103
            // ) {
            //   item.questionContext.subQuestions.forEach((item, index) => {
            //     item.questionId = index + 1;
            //     item.doAnswer = "";
            //     item.questionScore = 0;
            //     item.isCorrect = 2;
            //   });
            // }
            // }
          });
        });
        // 处理批语（总）
        if(this.testPaperInfo.markerComment){
          this.testPaperInfo.markerComment = this.handlerImg(this.testPaperInfo.markerComment)
        }
        // 第一次没有当前所做题目id设置第一个题目为当前所在题
        if (!this.testPaperInfo.currentQuestionId) {
          this.testPaperInfo.currentQuestionId =
            this.testPaperInfo.paperContext[0]?.questions[0]?.questionNumber; // 初始化默认第一个题目ID
          // 新增是否判分(提交后将该字段变为true，展示每题的答案，得分之类)
          this.testPaperInfo.isShowScoring = true;
        }
        this.$store.commit("exam/setTestExamInfo", this.testPaperInfo);
      }
    },
    // 富文本图片处理
    handlerImg(value) {
      value = value.replace(/<img\b([^>]*)>/gi, (match, attributes) => {
        // 1. 提取原有样式
        const styleMatch = attributes.match(/style\s*=\s*(["'])(.*?)\1/);
        let existingStyle = styleMatch ? styleMatch[2] : '';

        // 2. 添加/合并新样式（保留原有样式）
        if (!existingStyle.includes('max-width')) {
          existingStyle = `max-width:100%;height:auto;${existingStyle}`;
        } else {
          // 若已有max-width则仅补充height:auto
          existingStyle = existingStyle.replace(
            /max-width\s*:[^;]+;/i,
            '$&height:auto;'
          );
        }
        // 3. 替换或新增style属性
        return styleMatch
          ? match.replace(styleMatch[0], ` style="${existingStyle}"`)
          : match.replace(attributes, ` style="${existingStyle}" ${attributes}`);
      });
      return value
    },
    // 上一题
    getPreviousQuestion() {
      // 回到顶部
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      this.testPaperInfo.paperContext.forEach((item, index) => {
        item.questions.forEach((sitem, sindex) => {
          if (sitem.questionNumber == this.testExamInfo.currentQuestionId) {
            if (sindex == 0) {
              if (index == 0) {
                this.$Dialog.toast("已经是第一题啦", { type: "warning" });
                return;
              } else {
                let questionLength =
                  this.testPaperInfo.paperContext[index - 1].questions.length;
                if (questionLength == 0) return;
                this.testExamInfo.currentQuestionId =
                  this.testPaperInfo.paperContext[index - 1].questions[
                    questionLength - 1
                  ].questionNumber;
                this.$store.commit(
                  "exam/setCurrentQuestionId",
                  this.testPaperInfo.paperContext[index - 1].questions[
                    questionLength - 1
                  ].questionNumber
                );
                return;
              }
            } else {
              this.testExamInfo.currentQuestionId =
                item.questions[sindex - 1].questionNumber;
              this.$store.commit(
                "exam/setCurrentQuestionId",
                item.questions[sindex - 1].questionNumber
              );
              return;
            }
          }
        });
      });
    },
    // 下一题
    getNextQuestion() {
      // 回到顶部
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
      // 通关模式（判断对错，错了直接提交）
      if (this.testExamInfo.otherRule?.mode == 2) {
        let flag = this.judgeIsCorrect();
        if (flag == false) {
          this.commitPaper(3);
          return;
        }
      } else if (this.testExamInfo.otherRule?.mode == 3) {
        // 控制不给做了
        this.showAnalysis(true);
        // 错题累加
        this.pushWrongQuestion();
      }
      let shouldBreak = false; // 添加终止标记

      // 外层循环改用 for 替代 forEach
      // outerLoop:
      for (
        let index = 0;
        index < this.testPaperInfo.paperContext.length;
        index++
      ) {
        const item = this.testPaperInfo.paperContext[index];

        // 内层循环改用 for 替代 forEach
        for (let sindex = 0; sindex < item.questions.length; sindex++) {
          const sitem = item.questions[sindex];

          if (sitem.questionNumber === this.testExamInfo.currentQuestionId) {
            // 逻辑判断
            if (sindex === item.questions.length - 1) {
              if (index === this.testPaperInfo.paperContext.length - 1) {
                this.$Dialog.toast("已经是最后一题啦", { type: "warning" });
              } else {
                if (
                  !this.$Tools.empty(
                    this.testPaperInfo.paperContext[index + 1].questions[0]
                  )
                ) {
                  this.testExamInfo.currentQuestionId =
                    this.testPaperInfo.paperContext[
                      index + 1
                    ].questions[0].questionNumber;
                  this.$store.commit(
                    "exam/setCurrentQuestionId",
                    this.testPaperInfo.paperContext[index + 1].questions[0]
                      .questionNumber
                  );
                }
              }
            } else {
              this.testExamInfo.currentQuestionId =
                item.questions[sindex + 1].questionNumber;
              this.$store.commit(
                "exam/setCurrentQuestionId",
                item.questions[sindex + 1].questionNumber
              );
            }

            shouldBreak = true; // 标记需要终止
            break; // 终止内层循环
          }

          if (shouldBreak) break; // 检查外层终止标记
        }

        if (shouldBreak) break; // 终止外层循环
      }
    },
    // 错题模式
    pushWrongQuestion() {
      if (!this.$Tools.empty(this.testExamInfo.questionBank)) {
        // 超出可加题库不再累加
        if (this.pushIndex >= this.testExamInfo.questionBank.length) return;
        // 判断该题型是否存在。不存在要重新新建题型push
        let isExist = this.testPaperInfo.paperContext.findIndex(
          (item) =>
            item.questionTypeId ==
            this.testExamInfo.questionBank[this.pushIndex].questionTypeId
        );
        if (isExist == -1) {
          this.testPaperInfo.paperContext.push({
            paperNumber: "",
            questionTypeId:
              this.testExamInfo.questionBank[this.pushIndex].questionTypeId,
            questionTypeName:
              this.testExamInfo.questionBank[this.pushIndex].questionTypeName,
            questions: [this.testExamInfo.questionBank[this.pushIndex]],
          });
        } else {
          this.testPaperInfo.paperContext.forEach((item) => {
            if (
              this.testExamInfo.questionBank[this.pushIndex].questionTypeId ==
              item.questionTypeId
            ) {
              item.questions.push(
                this.testExamInfo.questionBank[this.pushIndex]
              );
            }
          });
        }
        this.pushIndex++;
      }
    },
    // 通关模式（判断当前题目是否正确）
    judgeIsCorrect() {
      let flag = true;
      this.testPaperInfo.paperContext.forEach((item) => {
        item.questions.forEach((sitem) => {
          if (sitem.questionNumber == this.testExamInfo.currentQuestionId) {
            // 错误则直接提交试卷或错题累加
            if (sitem.isCorrect == 2) {
              flag = false;
            }
          }
        });
      });
      return flag;
    },
    // 普通模式展示解析
    showAnalysis(flag) {
      // 通关模式（判断对错，错了直接提交）
      if (this.testExamInfo.otherRule?.mode == 2) {
        let flag = this.judgeIsCorrect();
        if (flag == false) {
          this.commitPaper(3);
        }
      } else if (this.testExamInfo.otherRule?.mode == 3) {
        // 错题累加
        this.pushWrongQuestion();
      }
      this.testPaperInfo.paperContext.forEach((item) => {
        item.questions.forEach((sitem) => {
          if (sitem.questionNumber == this.testExamInfo.currentQuestionId) {
            if (!flag) {
              if (sitem.questionContext.isFinish == false) {
                this.$Dialog.toast("请先完成答题后再查看");
              } else {
                sitem.showAnalysis = true;
              }
            } else {
              sitem.showAnalysis = true;
            }
          }
        });
      });
    },
    // 提交试卷
    commitPaper(isSubmit) {
      let listParams = {
        paperId: this.testExamInfo.paperId,
        examId: this.testExamInfo.examId,
        isSubmit: isSubmit, // 是否提交：1：提交 2：未提交保存进度
        questions: [],
      };
      this.testExamInfo.paperContext.forEach((item) => {
        item.questions.forEach((sitem) => {
          // 这里处理下多选题的答案和用户答案的数据结构将数组转换成字符串
          if (sitem.questionTypeId == 2) {
            if (Array.isArray(sitem.questionContext.answer)) {
              sitem.questionContext.answer =
                sitem.questionContext.answer.join(",");
            }
            if (Array.isArray(sitem.questionContext.doAnswer)) {
              sitem.questionContext.doAnswer =
                sitem.questionContext.doAnswer.join(",");
            }
            if (Array.isArray(sitem.doAnswer)) {
              sitem.doAnswer = sitem.doAnswer.join(",");
            }
          }
          if (sitem.questionTypeId == 99 || item.questionTypeId == 101 || item.questionTypeId == 102 || item.questionTypeId == 103) {
            sitem.questionContext.subQuestions.forEach((ssitem) => {
              // 综合解答下的多选题
              if (ssitem.type == 2) {
                // let aaa = this.$Tools.copyObj(ssitem);
                // 判断题处理数据格式
                if (Array.isArray(ssitem.answer)) {
                  ssitem.answer = ssitem.answer.join(",");
                }
                if (Array.isArray(ssitem.doAnswer)) {
                  ssitem.doAnswer = ssitem.doAnswer.join(",");
                }
                // return aaa
              }
            });
          }
          // 作文题
          if (sitem.questionTypeId == 21 || item.questionTypeId == 22) {
            sitem.doAnswer = JSON.stringify(sitem.doAnswer);
          }
          listParams.questions.push(sitem);
        });
      });
      if (this.isChallengeSubmit) {
        listParams.sort = this.challengeSort;
      }

      this.$Api.exam
        .saveExam(listParams)
        .then((res) => {
          // this.$Dialog.toast("提交成功");
          this.$emit("refreshTextExam");
          setTimeout(() => {
            if (this.isChallengeSubmit) {
              this.paperCommitBackInfo = res?.data?.data;
              this.changeExamInfoIsShowScoring();
            }
          }, 1000);
        })
        .catch(() => { });
    },
    // 试题提交控制显示试卷的结果分数
    changeExamInfoIsShowScoring() {
      this.testExamInfo.isShowScoring = true;
      // 默认到第一题
      this.testExamInfo.currentQuestionId = 1;
      this.$store.commit("exam/setTestExamInfo", this.testExamInfo);
    },
    // 答题(刷新缓存试题便于提交)
    answerQuestion(info) {
      if (this.testPaperInfo.paperContext) {
        // 1. 使用 map 返回新 paperContext 数组
        const newPaperContext = this.testPaperInfo.paperContext.map((item) => {
          // 2. 使用 map 返回新 questions 数组
          const newQuestions = item.questions.map((sitem) => {
            if (sitem.questionNumber === info.questionNumber) {
              // 返回替换后的新对象
              return this.$Tools.copyObj(info);
            } else {
              // 保留原对象
              return sitem;
            }
          });

          // 3. 将新 questions 数组赋值回当前 item
          return { ...item, questions: newQuestions };
        });

        // 4. 更新整个 paperContext
        this.testPaperInfo.paperContext = newPaperContext;
        this.$store.commit("exam/setTestExamInfo", this.testPaperInfo);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.test_paper {
  .paper_top {
    .empty {
      width: 1px;
      height: 1px;
    }

    .exercise-title {
      font-size: 18px;
      font-weight: 600;
    }

    .count_down {
      // width: 170px;
      height: 36px;
      background: linear-gradient(-42deg, #f45f0a 1%, #ed752f 100%);
      box-shadow: 0px 0px 9px 0px rgba(254, 121, 47, 0.53),
        0px 3px 3px 0px rgba(255, 255, 255, 0.23);
      border-radius: 10px;
      color: #ffffff;
      padding: 0 20px;
      line-height: 36px;
      margin-left: 60px;
    }

    .back_icon {
      width: 28px;
      height: 28px;
    }

    .back_text {
      font-size: 14px;
      color: #13d6aa;
      margin-left: 7px;
    }
  }

  .test_title {
    font-size: 20px;
    color: #111111;
    text-align: center;
  }

  .test_type {}

  .btn_box {
    justify-content: center;

    .btn_previous_question {
      width: 200px;
      height: 48px;
      border-radius: 24px;
      border: 1px solid #13d6aa;
      line-height: 48px;
      text-align: center;
      color: #13d6aa;
      font-size: 18px;
    }

    .btn_next_question {
      width: 200px;
      height: 48px;
      background: linear-gradient(90deg, #00d5c2, #00d498);
      border-radius: 24px;
      line-height: 48px;
      text-align: center;
      color: #ffffff;
      font-size: 18px;
    }
  }
}
</style>